import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import Button from "components/CustomButtons/Button.jsx";
import Config from "../../config/";
const ROOT_URL = Config.rooturl;

class Vessellistdt extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datatable: this.props.datatable
    };
  }

  render() {
    const columns = [
      {
        name: "id",
        label: "ID",
        options: {
          filter: false,
          display: false
        }
      },
      {
        label: "Vessel Name",
        name: "vessel_name",
        options: {
          filter: true
        }
      },
      {
        label: "Vessel Captain",
        name: "vessel_captain",
        options: {
          filter: true
        }
      },
      {
        label: "IMO",
        name: "imo",
        options: {
          filter: true
        }
      },
      {
        label: "Flag",
        name: "flag",
        options: {
          filter: true
        }
      },
      {
        label: "Fuel Main Engine",
        name: "fuel_main_engine",
        options: {
          filter: true
        }
      },
      {
        label: "Programmer",
        name: "proggramer",
        options: {
          filter: true
        }
      },
      {
        label: "Programmer Phone Ext",
        name: "proggramer_phone_ext",
        options: {
          filter: true
        }
      },
      {
        label: "Programmer Mobile Phone",
        name: "proggramer_mobile_phone",
        options: {
          filter: true
        }
      },
      {
        label: "Email",
        name: "email",
        options: {
          filter: true
        }
      },
      {
        label: "Vessel Number",
        name: "vessel_number",
        options: {
          filter: true
        }
      },
      {
        label: "Vessel Type",
        name: "vessel_type",
        options: {
          filter: true
        }
      },
      {
        label: "Call Sign",
        name: "call_sign",
        options: {
          filter: true
        }
      },
      {
        label: "Vessel Status",
        name: "vessel_status",
        options: {
          filter: true
        }
      },
      {
        label: "Ownership Status",
        name: "ownership_status",
        options: {
          filter: true
        }
      },
      {
        label: "Vessel Category",
        name: "vessel_category",
        options: {
          filter: true
        }
      },
      {
        label: "Ship Id",
        name: "ship_id",
        options: {
          filter: true
        }
      },
      {
        label: "Programmer ID",
        name: "programer_id",
        options: {
          filter: true,
          display: false
        }
      },

      // {
      //   label: "Latitude",
      //   name: "latitude",
      //   options: {
      //     filter: true
      //   }
      // },
      // {
      //   label: "Longitude",
      //   name: "longitude",
      //   options: {
      //     filter: true
      //   }
      // },
      // {
      //   label: "Description",
      //   name: "urlfile",
      //   options: {
      //     filter: true,
      //     customBodyRender: val => (
      //       <a href = {`${ROOT_URL}${val}`} download>
      //         {val}
      //       </a>
      //     )
      //   }
      // },

      {
        name: "Action",
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            let id = tableMeta.rowData !== undefined ? tableMeta.rowData[0] : 0;
            let ship_id =
              tableMeta.rowData !== undefined ? tableMeta.rowData[16] : 0;
            let searchProgrammer = tableMeta.rowData[17];

            if (localStorage.getItem("userlevel") != 3) {
              return (
                <div>
                  <Button
                    color="behance"
                    size="sm"
                    round
                    onClick={() => this.props.handleUpdate(id, ship_id, searchProgrammer)}
                  >
                    Update
                  </Button>
                  <Button
                    color="danger"
                    size="sm"
                    round
                    onClick={() => this.props.handleDelete(id, ship_id)}
                  >
                    Delete
                  </Button>
                </div>
              );
            } else {
              return <div />;
            }
          }
        }
      }
    ];

    const options = {
      filter: false,
      //filterType: "dropdown",
      selectableRows: false,
      responsive: "scroll",
      textLabels: {
        body: {
          noMatch: this.props.loader
            ? "Searching..."
            : "Sorry, no matching records found"
        }
      }
    };

    return (
      <MUIDataTable
        title={"Vessel"}
        data={this.props.datatable}
        columns={columns}
        options={options}
      />
    );
  }
}

export default Vessellistdt;
